import * as Linking from 'expo-linking';

// Generate a URL prefix from your app's custom scheme defined in app.json
const prefix = Linking.createURL('/');

export const linkingObject = {
  prefixes: [prefix, 'https://monetareport.net', 'monetareport.net'],
  config: {
    screens: {
      Login: 'login',
      PreviousReport: 'previous-report',
      ReportDetails: 'report-details',
      SubmitReport: 'submit-report',
      SubmitBug: 'submit-bug',
      Settings: 'settings',
      PrivacyPolicy: 'privacy-policy',
      AdminReportDetails: 'admin-report-details',
      UserManagement: 'user-management',
      ForgotPassword: 'forgot-password',
      ForgotPasswordInternal: 'forgot-password-internal',
      ResetPassword: 'reset-password',
      AdminFilterHome: 'admin-filter-home',
      AnalyticsScreen: 'analytics',
      OrganizationManagement: 'organization-management',
      ReportSubmitted: 'report-submitted',
      SignUp: 'sign-up',
    },
  },
};
